// TODO: curry type this

import { TCustomUserSession } from "@/types/app";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function buzz(...information: any) {
	try {
		if (process.env.NODE_ENV === "production") {
			const text = information.join(" ");

			const body = { text };

			const slackWebhookUrl = process.env.SLACK_LOGS_WEBHOOK_URL;

			if (!slackWebhookUrl) {
				throw new Error("Slack webhook URL not configured");
			}

			const url = new URL(slackWebhookUrl);

			await fetch(url, {
				method: "POST",
				body: JSON.stringify(body),
			});
		}
	} catch (error) {
		console.log(`BUZZ ERROR : ${error}`);
	}
}
//Note:slack notification is disabled for now, we are using discord and zoho cliq channel, in future we will use slack as well
// eslint-disable-next-line @typescript-eslint/no-explicit-any
/*export async function bee(information: any) {
	try {
		const slackWebhookUrl = process.env.SLACK_BEE_APP_WEBHOOK_URL;

		if (!slackWebhookUrl) {
			throw new Error("Slack webhook URL not configured");
		}

		const url = new URL(slackWebhookUrl);

		await fetch(url, {
			method: "POST",
			body: JSON.stringify(information),
		});
	} catch (error) {
		console.log(`BEE ERROR : ${error}`);
	}
}*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function sendDiscordNotification(message: any) {
	try {
		const webhookUrl = process.env.DISCORD_LOGS_WEBHOOK_URL;

		if (!webhookUrl) {
			throw new Error("Discord webhook URL not configured");
		}

		const response = await fetch(webhookUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ content: message }),
		});

		if (!response.ok) {
			throw new Error(`Failed to send notification: ${response.statusText}`);
		}

		return await response.text();
	} catch (error) {
		console.error("Error sending discord notification:", error);
	}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function sendZohoCliqChannelNotification(message: any) {
	try {
		const zohoUrl = process.env.ZOHO_CLIQ_CHANNEL_URL;
		if (!zohoUrl) {
			throw new Error("Zoho Cliq channel API URL not configured");
		}
		const response = await fetch(zohoUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ text: message }),
		});

		if (!response.ok) {
			throw new Error(`Failed to send Zoho Cliq channel notification: ${response.statusText}`);
		}
		return await response.text();
	} catch (error) {
		console.error("Error sending Zoho Cliq channel notification:", error);
	}
}
export default buzz;

type LogType = "error" | "info" | "debug";
type LogEvent =
	| "user_created"
	| "general"
	| "fcm_notification"
	| "logger_init"
	| "email_notification";
type LogOptions = { logType: LogType; event?: LogEvent };

class Logger {
	constructor(private logDBUrl: string, private sessionUser?: TCustomUserSession) {
		this.d = this.d.bind(this);
		this.i = this.i.bind(this);
		this.e = this.e.bind(this);
		this.log = this.log.bind(this);
	}

	private async log(message: string, options?: LogOptions) {
		console.log("Starting fetch request");
		const url = `${this.logDBUrl}/items/log`;
		const now = new Date().toISOString();
		const body = JSON.stringify({
			sessionUser: this.sessionUser?.id,
			logType: options?.logType,
			event: options?.event ?? "GENERAL",
			message: message,
			createdAt: now,
		});
		try {
			console.log(`Sending request to: ${url}`);
			console.log(`Request body: ${body}`);
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: body,
			});

			if (!response.ok) {
				console.error(`Failed to log: ${response.status} ${response.statusText}`);
				const responseText = await response.text();
				console.error(`Response: ${responseText}`);
			} else {
				console.log("Log entry created successfully");
				const responseText = await response.text();
				console.log(`Response: ${responseText}`);
			}
		} catch (error) {
			console.error("Error creating log entry:", error);
		}
	}

	d = (message: string, options?: Omit<LogOptions, "logType">) =>
		this.log(message, {
			logType: "debug",
			...options,
		});

	i = (message: string, options?: Omit<LogOptions, "logType">) =>
		this.log(message, {
			logType: "info",
			...options,
		});

	e = (message: string, options?: Omit<LogOptions, "logType">) =>
		this.log(message, {
			logType: "error",
			...options,
		});
}

export const Log = new Logger("https://cms.proptechbuzz.com");
